import { Link } from "react-router-dom";
import { CATEGORIES } from "../data/products";

export default function CategoryNav() {
  return (
    <div className="header" style={{ borderTop: "1px solid var(--border)", padding: "10px 24px" }}>
      <nav style={{ display: 'flex', gap: '20px', fontSize: '14px' }}>
        <Link to="/shop" style={{ marginLeft: 0 }}><b>All Products</b></Link>
        {CATEGORIES.map((cat) => (
          <Link key={cat} to={`/shop?category=${encodeURIComponent(cat)}`} style={{ marginLeft: 0 }}>
            {cat}
          </Link>
        ))}
      </nav>
    </div>
  );
}
